import React, { useEffect, useRef, useState } from 'react';
import "bootstrap/dist/css/bootstrap.min.css";
import apis from '../../api';
import { Button } from 'primereact/button';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Toolbar } from 'primereact/toolbar';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';
import { Dialog } from 'primereact/dialog';
import { Calendar } from 'primereact/calendar';
import { LabelField } from './Employes.styles';
import dateFormat from '../../services/DateFormat.service';
import '../../DataTableDemo.css';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Employes
Description : Pagina de Appointment para el CRUD de los empleados del aplicativo remunerlite.
Date Autor Modification
================================================================================
23/10/2021 Cristian Andres Pizo Mina - Pagina de Empleados
5/4/2022 Cristian Andres Pizo Mina - Comentarios
================================================================================ */

export default function Employes() {

  // declarar constantes
  const [headCount, setHeadCount] = useState([])
  const [loading, setLoading] = useState(false);
  const [isOpenHC, setIsOpenHC] = React.useState(false);
  const elementWidth = { width: "20rem", justifySelf: "center" }

  const headers = { authorization: localStorage.getItem('token') }
  const [products, setProducts] = useState([]);
  const [first2, setFirst2] = useState(0);
  const [rows2, setRows2] = useState(5);
  const [selectedProducts, setSelectedProducts] = useState(null);
  const [filters1, setFilters1] = useState(null);
  const [globalFilterValue1, setGlobalFilterValue1] = useState('');

  const toast = useRef(null);

  // funcion para obtener los empleados
  useEffect(() => {
    const template = async () => {
      let contenidoTabla = []
      // await apis.getBusiness(headers).then(res => {
      //   localStorage.setItem('client', res.data.COMPANY[0]["CLIENT"]);
      // })
      await apis.getContracts_client(localStorage.getItem('client'), headers).then(res => {
        let data = res.data.CONTRACTS;
        data.forEach(element => {
          let status = element["STATUS"].split("-")
          let contractType = element["CONTRACT_TYPE"].split("-")
          contenidoTabla.push({
            CONTRACT_ID: element.CONTRACT_ID, NAME: element.NAME, CONTRACT_TYPE_ID: contractType[0],
            CONTRACT_TYPE: contractType[1], JOB_ID: element.JOB_ID, NUMBER_ID: element.NUMBER_ID, STATUS_ID: status[0],
            STATUS: status[1], START_DATE: element.START_DATE, END_DATE: element.END_DATE, RETIREMENT_DATE: element.RETIREMENT_DATE,
          })
        })
        setProducts(contenidoTabla)
      })
    }
    template()
  }, []);

  //función para enviar a la pagina CreatePerson agregando o editando elementos number_id,contract_id del local storage
  function editPerson(person) {
    localStorage.setItem('number_id', person.NUMBER_ID);
    localStorage.setItem('contract_id', person.CONTRACT_ID);
    window.location.href = "./CreatePerson"
  }

  //Función para enviar a la pagina CreatePerson y eliminar elementos number_id,contract_id del local storage
  function createPerson() {
    localStorage.removeItem('number_id');
    localStorage.removeItem('contract_id');
    window.location.href = "./CreatePerson"
  }


  //Función para redirecionar a la pagina Social_benefits
  function liquidar() {
    window.location.href = "/Social_benefits"
  }

  const showModalHC = () => {
    setIsOpenHC(true);
  };

  const hideModalHC = () => {
    setIsOpenHC(false);
  };

  const footerHC = (
    <div>
      <Button label="Generar" loading={loading} onClick={() => { setLoading(true); postHeadCountReport() }} />
    </div>
  );

  const headerHC = (
    <div>
      <h3>Parámetros reporte head count</h3>
    </div>
  )

  function handleChangeHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { ...e.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeDateHC(e, d, index) {
    let date = dateFormat(e.value)
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: date, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }

  async function handleChangeTextHC(e, d, index) {
    setHeadCount(h => {
      let newHeadCount = [...h]
      newHeadCount[index] = { CODE: e.target.value, LABEL: d.TAG, SHEET: d.SHEET_POSITION }
      return newHeadCount
    })
  }
  async function postHeadCountReport() {
    /*Función encargada de cargar la informacion del reporte head count*/
    let finalReport = []
    const client = localStorage.getItem('client')
    const option = "1"
    let report = {
      CLIENT: client,
      OPTION: option,
      REPORTS: []
    }
    let max = 0
    headCount.forEach(n => {
      let size = n.SHEET.length
      if (size > max) {
        max = size
      }
    })
    for (let i = 0; i < max; i++) {
      report.REPORTS.push({ PARAMETERS: [] })
    }

    headCount.forEach(h => {
      h.SHEET.forEach(e => {
        report.REPORTS[e].PARAMETERS.push({ LABEL: h.LABEL, VALUE: h.CODE })
      })
    })
    try {
      await apis.postReportHeadCount(report, headers).then(res => {
        finalReport = res.data
        generatePayrollReport(finalReport, "reporteHeadCount")
        setLoading(false)
        toast.current.show({ severity: 'success', summary: 'Éxito', detail: "Reporte head count generado existosamente" });
        hideModalHC();
      })
    }
    catch (err) {
      setLoading(false)
      toast.current.show({ severity: 'warn', summary: 'Aviso', detail: err.response.data.message, sticky: true });
    }
  }

  function generatePayrollReport(reporte, nombre) {
    /*Función encargada de construir el archivo Excel del reporte*/
    import("xlsx").then(xlsx => {
      const workbook = xlsx.utils.book_new();
      reporte["SHEETS"].forEach(sheet => {
        let sheetLines = []
        sheet["DETAIL"].forEach(line => {
          let fila = line.LINE.split("|")
          sheetLines.push(fila)
        })
        const worksheet = xlsx.utils.aoa_to_sheet(sheetLines)
        xlsx.utils.book_append_sheet(workbook, worksheet, sheet.NAME)
      })
      const excelBuffer = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
      saveAsExcelFile(excelBuffer, nombre)
    })
  }

  const saveAsExcelFile = (buffer, fileName) => {
    /*Función encargada de guardar y descargar el archivo Excel del reporte*/
    import('file-saver').then(FileSaver => {
      let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data = new Blob([buffer], {
        type: EXCEL_TYPE
      });
      FileSaver.default.saveAs(data, fileName + '_' + dateFormat(new Date()) + EXCEL_EXTENSION);
    });
  }

  //Evento para cambiar de pagina
  const onCustomPage2 = (event) => {
    setFirst2(event.first);
    setRows2(event.rows);
  }
  //Retorna componente del paginador de la tabla y se puede configurar el numero de elementos por pagina
  const template2 = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        { label: 5, value: 5 },
        { label: 10, value: 10 },
        { label: 20, value: 20 }
      ];

      return (
        <React.Fragment>
          <span className="mx-1" style={{ color: 'var(--text-color)', userSelect: 'none' }}>Elementos por pagina: </span>
          <Dropdown value={options.value} options={dropdownOptions} onChange={options.onChange} />
        </React.Fragment>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{ color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center' }}>
          {options.first} - {options.last} of {options.totalRecords}
        </span>
      )
    }
  };

  //Boton Agregar Persona izquierda de la tabla
  const leftToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Agregar" icon="pi pi-plus" className="p-button-success mr-2 p-button-sm " onClick={() => createPerson()} />

        {/* <Button label="Editar" icon="pi pi-user-edit" className="p-button-warning mr-2" onClick={()=> editPerson(selectedProducts)}/>
          <Button label="Delete" icon="pi pi-trash" className="p-button-danger" /> */}
      </React.Fragment>
    )
  }

  //Boton liquidar Nómina en la parte derecha de la tabla
  const rightToolbarTemplate = () => {
    return (
      <React.Fragment>
        <Button label="Liquidar Nómina" icon="pi pi-building" className="p-button mr-2 p-button-sm " onClick={() => liquidar()} />
        <Button label="Head count" icon="pi pi-book" className="p-button mr-2 p-button-sm " tooltip='Generar reporte head count' tooltipOptions={{ position: 'top' }} onClick={showModalHC} />
      </React.Fragment>
    )
  }

  //Boton editar persona de la tabla, en rowData se guarda el {} con todos los datos de la fila
  const actionBodyTemplate = (rowData) => {
    return <Button icon="pi pi-pencil" className="p-button-warning mr-2 p-button-sm text-xs" onClick={() => editPerson(rowData)} />
  }

  //Componente Header donde se encuetra el textLabel para el filtrado global y el boton de limpiar filtro
  const renderHeader1 = () => {
    return (
      <div className="flex justify-content-between">
        <Button type="button" icon="pi pi-filter-slash" label="Limpiar filtros" className="p-button-outlined p-button-sm " onClick={clearFilter1} />
        <IconField iconPosition="left">
          <InputIcon className="pi pi-search"> </InputIcon>
          <InputText value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Palabra clave" className="p-inputtext-sm" />
        </IconField>
      </div>
    )
  }

  //Función para encasular valor del filtro global y buscar con el filtro FilterMatchMode.CONTAINS
  const onGlobalFilterChange1 = (e) => {
    const value = e.target.value;
    let _filters1 = {
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS }
    };
    _filters1['global'].value = value;
    setFilters1(_filters1);
    setGlobalFilterValue1(value);
  }

  //Limpiar e inicializar los filtros
  const clearFilter1 = () => {
    initFilters1();
  }

  //Constante para insertar componente Header en la parte superior de la tabla donde se ubica el textLabel para el filtrado global
  const header1 = renderHeader1();

  //Limpiar filtros de la tabla
  const initFilters1 = () => {
    setFilters1({
      'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
      'CONTRACT_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NUMBER_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'NAME': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'JOB_ID': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'CONTRACT_TYPE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'STATUS': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'START_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'END_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
      'RETIREMENT_DATE': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
    });
    setGlobalFilterValue1('');
  }

  //Nombre de las opciciones para los filtros
  const matchModes = [
    { label: 'COMIENZA CON', value: FilterMatchMode.STARTS_WITH },
    { label: 'CONTIENE', value: FilterMatchMode.CONTAINS },
    { label: 'NO CONTIENE', value: FilterMatchMode.NOT_CONTAINS },
    { label: 'TERMINA CON', value: FilterMatchMode.ENDS_WITH },
    { label: 'IGUAL A', value: FilterMatchMode.EQUALS },
    { label: 'DIFERENTE A', value: FilterMatchMode.NOT_EQUALS }
  ];

  // Return que entrega la pantalla
  return (
    <div className='mt-6'>

      <div className="surface-100 px-4 py-5 md:px-6 lg:px-8">
        <Toast ref={toast} />

        <div className="mb-3 font-bold text-4xl mt-6">
          <span className="text-900">Empleados</span>
        </div>


        <div className="card mt-4">
          <Toolbar className="mb-4" left={leftToolbarTemplate} right={rightToolbarTemplate} ></Toolbar>
          <DataTable className="text-xs" value={products} paginator paginatorTemplate={template2} first={first2} rows={rows2} onPage={onCustomPage2}
            responsiveLayout="scroll" selection={selectedProducts} onSelectionChange={(e) => setSelectedProducts(e.value)} dataKey="CONTRACT_ID"
            size="small" filters={filters1} filterDisplay="menu" globalFilterFields={['CONTRACT_ID', 'NUMBER_ID', 'NAME', 'JOB_ID', 'CONTRACT_TYPE', 'STATUS', 'START_DATE', 'END_DATE', 'RETIREMENT_DATE']}
            header={header1} >
            <Column selectionMode="single" headerStyle={{ width: '3em' }}></Column>
            <Column field="CONTRACT_ID" header="Contrato" filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por contrato" sortable></Column>
            <Column field="NUMBER_ID" header="Identificación" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Identificación" sortable></Column>
            <Column field="NAME" header="Nombre" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Nombre" sortable></Column>
            <Column field="JOB_ID" header="Cargo" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Cargo" sortable></Column>
            <Column field="CONTRACT_TYPE" header="Tipo de contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Tipo de contrato" sortable></Column>
            <Column field="STATUS" header="Estado" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por Estado" sortable></Column>
            <Column field="START_DATE" header="Fecha ingreso" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha ingreso" sortable></Column>
            <Column field="END_DATE" header="Fecha fin contrato" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha fin contrato" sortable></Column>
            <Column field="RETIREMENT_DATE" header="Fecha retiro" showFilterOperator={false} filterMatchModeOptions={matchModes} filter filterPlaceholder="Buscar por fecha retiro" sortable></Column>
            <Column headerStyle={{ width: '4rem', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} body={actionBodyTemplate} />
          </DataTable>
        </div>

      </div>

    </div>
  );
} 